import React from 'react';
import styled from 'styled-components';

const FallbackCard = styled.div`
  width: 170px;
  min-width: 170px;
  height: 100%;
  background: ${({ theme }) => theme.colors.cardBackground};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  text-align: center;
  position: relative;
  overflow: hidden;
`;

const ErrorIcon = styled.div`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.warning};
  margin-bottom: 8px;
`;

const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 12px;
  margin: 0 0 8px 0;
  line-height: 1.2;
`;

const RetryButton = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
  }

  &:active {
    transform: translateY(1px);
  }
`;


interface GameCardFallbackProps {
  gameName?: string;
  error?: Error;
  onRetry?: () => void;
}

export const GameCardFallback: React.FC<GameCardFallbackProps> = ({ gameName, error: _error, onRetry }) => {
  return (
    <FallbackCard>
      <ErrorIcon>⚠️</ErrorIcon>
      <ErrorMessage>
        {gameName} game
        <br />
        temporarily unavailable
      </ErrorMessage>
      {onRetry && <RetryButton onClick={onRetry}>Try Again</RetryButton>}
    </FallbackCard>
  );
};
